import { Component, Injectable, input, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { est } from 'src/app/shared/utilities/date'

@Injectable()
export class StringDateAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-'

  override fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const [year, month, day] = value.split(this.DELIMITER)
      const today = est()
      const todayDay = today.getDay()
      const todayMonth = today.getMonth() + 1
      const todayYear = today.getFullYear()
      return {
        day:
          day?.length === 2
            ? parseInt(day ?? `${todayDay}`.padStart(2, '0'), 10) || todayDay
            : todayDay,
        month:
          month?.length === 2
            ? parseInt(month ?? `${todayMonth}`.padStart(2, '0'), 10) ||
              todayMonth
            : todayMonth,
        year:
          year?.length === 4
            ? parseInt(year ?? `${todayYear}`.padStart(4, '0'), 10) || todayYear
            : todayYear,
      }
    }
    return null
  }
  override toModel(date: NgbDateStruct | null): string | null {
    return date
      ? `${date.year}`.padStart(2, '0') +
          this.DELIMITER +
          `${date.month}`.padStart(2, '0') +
          this.DELIMITER +
          `${date.day}`.padStart(2, '0')
      : ''
  }
}

@Injectable()
export class StringDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/'

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const [month, day, year] = value.split(this.DELIMITER)
      const today = est()
      const todayDay = today.getDay()
      const todayMonth = today.getMonth() + 1
      const todayYear = today.getFullYear()
      return {
        day:
          day?.length === 2
            ? parseInt(day ?? `${todayDay}`.padStart(2, '0'), 10) || todayDay
            : todayDay,
        month:
          month?.length === 2
            ? parseInt(month ?? `${todayMonth}`.padStart(2, '0'), 10) ||
              todayMonth
            : todayMonth,
        year:
          year?.length === 4
            ? parseInt(year ?? `${todayYear}`.padStart(4, '0'), 10) || todayYear
            : todayYear,
      }
    }
    return null
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? `${date.month}`.padStart(2, '0') +
          this.DELIMITER +
          `${date.day}`.padStart(2, '0') +
          this.DELIMITER +
          `${date.year}`.padStart(2, '0')
      : ''
  }
}

@Component({
  selector: 'div[dateStringPicker]',
  imports: [FormsModule, NgbDatepickerModule, MatIcon],
  providers: [
    { provide: NgbDateAdapter, useClass: StringDateAdapter },
    { provide: NgbDateParserFormatter, useClass: StringDateParserFormatter },
  ],
  styles: `
    .input-with-btn {
        position: relative;
        border: 1px solid black;
        border-radius: 0.25rem;

        button {
            position: absolute;
            border: 1px solid transparent;
            border-top-right-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
            border-left-color: black;
            width: 3rem;
            height: 100%;
            right: 0;
            overflow: hidden;

            mat-icon {
                margin-top: -2px;
            }
        }
    }

    .text-input {
        border: none;
        border-radius: 0.25rem;
        height: 1.5rem;
        font-size: 0.9rem;
        width: 100%;
        padding: 0 3rem 0 1.5rem;
        overflow: hidden;
        outline: none;
    }
  `,
  template: `
    <div class="input-with-btn">
      <input
        #dp="ngbDatepicker"
        #state="ngModel"
        class="text-input"
        placeholder="MM/dd/yyyy"
        ngbDatepicker
        name="dp"
        [ngModel]="value()"
        (ngModelChange)="valueChange.emit($event)"
        placement="bottom-right"
        [positionTarget]="toggle"
        (keyup)="handleKeyup($event)"
      />

      <button #toggle (click)="dp.toggle()" type="button">
        <mat-icon svgIcon="calendar_month"> </mat-icon>
      </button>
    </div>
  `,
})
export class DateStringPickerComponent {
  readonly value = input.required<string>()
  readonly valueChange = output<string>()
  readonly enter = output()

  protected handleKeyup(evt: KeyboardEvent){
    if(evt.key === 'Enter') {
      this.enter.emit()
    }
  }
}
